import { useEffect } from 'react'
import { router } from '@inertiajs/react'

// Reloads the current page's props every `ms` without a full navigation.
export default function usePoll(ms = 15000, only = null) {
  useEffect(() => {
    const id = setInterval(() => {
      router.reload(only ? { only } : {})
    }, ms)
    return () => clearInterval(id)
  }, [ms, only])
}
